import type { ApolloError } from '@apollo/client';

import { isGraphQLAuthError } from 'src/modules/error-handling/error-handling';
import type { ActionName } from 'src/types';

import { Actions, type LanguageAction } from './actions';

export const updateLanguage = (action: ActionName): LanguageAction => ({
  type: Actions.UPDATE_LANGUAGE_START,
  actionName: action,
  meta: {
    metrics: {
      action,
    },
  },
});

export const updateLanguageSuccess = (): LanguageAction => ({
  type: Actions.UPDATE_LANGUAGE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const updateLanguageFailure = (error: ApolloError): LanguageAction => ({
  type: Actions.UPDATE_LANGUAGE_FAILURE,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});

export const removeLanguage = (): LanguageAction => ({
  type: Actions.REMOVE_LANGUAGE_START,
  actionName: 'DELETE',
});

export const removeLanguageSuccess = (): LanguageAction => ({
  type: Actions.REMOVE_LANGUAGE_SUCCESS,
  meta: {
    metrics: {
      'profile-update': true,
    },
  },
});

export const removeLanguageFailure = (error: ApolloError): LanguageAction => ({
  type: Actions.REMOVE_LANGUAGE_FAILURE,
  meta: {
    metrics: {
      error: !isGraphQLAuthError(error),
    },
  },
});
